import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ReportModule } from '../report/report.module';
import { ReportsWidgetComponent } from './reports-widget.component';

@NgModule({
    declarations: [ReportsWidgetComponent],
    imports: [CommonModule, ReportModule, TranslateModule, TwcModule],
    exports: [ReportsWidgetComponent],
})
export class ReportsWidgetModule {}
